import { z } from 'zod';

export const quoteSchema = (t: (key: string) => string) =>
  z.object({
    originDepartment: z.string().optional().default(''),
    originPostalCode: z.string().optional(),
    originCountry: z.string().optional(),
    destDepartment: z.string().optional().default(''),
    destPostalCode: z.string().optional(),
    destCountry: z.string().optional(),
    // Virgule decimale acceptee : une cotation a la tonne se saisit « 6,3 ».
    quantity: z.preprocess(
      (v) => (typeof v === 'string' ? v.replace(',', '.').trim() : v),
      z.coerce.number().positive(t('quote.minPositive')),
    ),
    unit: z.string().min(1),
    date: z.string().min(1, t('quote.dateRequired')),
  }).superRefine((v, ctx) => {
    // Le code postal suffit à localiser un point ; le département n'est exigé
    // qu'en son absence. Hors France, le département est la région NUTS3 du pays.
    for (const side of ['origin', 'dest'] as const) {
      const dept = v[`${side}Department`];
      const cp = v[`${side}PostalCode`];
      if (dept?.trim() || cp?.trim()) continue;
      ctx.addIssue({ code: 'custom', path: [`${side}Department`], message: t('quote.departmentOrPostalRequired') });
    }
  });

export type QuoteFormValues = z.infer<ReturnType<typeof quoteSchema>>;

/** Options de repli quand le catalogue prestations n'est pas encore chargé. */
export const fallbackOptions = (
  t: (key: string) => string,
): { value: string; label: string; group?: string | null }[] => [
  { value: 'HAYON', label: t('quote.fallbackOptions.tailLift') },
  { value: 'LIVRAISON_RDV', label: t('quote.fallbackOptions.byAppointment') },
  { value: 'ETAGE', label: t('quote.fallbackOptions.upstairs') },
];
